'use client';

// Thin analytics shim for the comparison surface (A-1/A-2). Fans out to both
// PostHog and the GTM/GA dataLayer if present; no-ops otherwise.

type Props = Record<string, unknown>;

interface AnalyticsWindow {
  posthog?: { capture: (event: string, props?: Props) => void };
  dataLayer?: Props[];
}

export function track(event: string, props: Props = {}): void {
  if (typeof window === 'undefined') return;
  const w = window as unknown as AnalyticsWindow;
  try {
    w.posthog?.capture(event, props);
    if (Array.isArray(w.dataLayer)) w.dataLayer.push({ event, ...props });
  } catch {
    // analytics must never break the page
  }
}
